export enum ADDRESS_TYPES {
	HOME = 'Home',
	WORK = 'Work',
	MAIL = 'Mail',
	OTHER = 'Other'
}
